const SpecificationStyleConfig = {
  collection: "attribute_styles",
  fields: ["id", "name", "value"],

  adapter: class SpecificationStyle {
    constructor(spec_style) {
      this.id = spec_style.id;
      this.name = spec_style.name;
      this.value = spec_style.value;
    }
  }
};

export default SpecificationStyleConfig;
